<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div>
      <app-admin-card-with-title [cardTitle]="basicDataTitle"
                                 [isContentVisible]="!isBasicDataCollapsed" [showToggleButton]="true">
        <div class="row">
          <div class="col-12 col-md-2 d-flex justify-content-start justify-content-xl-center">
            <div class="circle">
              @if (userDetails?.picture) {
                <img [src]="userDetails?.picture">
              } @else {
                <p>
                  {{ userDetails?.firstname?.charAt(0)?.toUpperCase() }}{{
                    userDetails?.lastname?.charAt(
                      0)?.toUpperCase()
                  }}
                </p>
              }
            </div>
          </div>
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="firstname"
                             label="{{t('app.common.first.name')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <app-input formControlName="lastname"
                           label="{{t('app.common.last.name')}}" [readonly]="true"></app-input>
              </div>
              <div class="col-xl-4 col-6">
                <app-input formControlName="gender"
                           label="{{t('app.common.gender')}}" [readonly]="true"></app-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="birthDay"
                             label="{{t('app.common.birthDay')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="userId"
                             label="{{t('app.common.id')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="role"
                             label="{{t('app.common.role')}}" [readonly]="true"></app-input>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4  col-6">
                <div class="mb-3">
                  <app-input formControlName="created"
                             label="{{t('app.common.created')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="modified"
                             label="{{t('app.common.modified')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4  col-6">
                <div class="mb-3">
                  <app-input formControlName="language"
                             label="{{t('app.common.language')}}" [readonly]="true"></app-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="email"
                             label="{{t('app.common.email')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="phoneNumber"
                             label="{{t('app.common.phone.number')}}" [readonly]="true"></app-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>
      @if (competitor) {
        <app-admin-card-with-title [cardTitle]="raceDataTitle"
                                   [isContentVisible]="!isRaceDataCollapsed" [showToggleButton]="true">
          <div class="row">
            <div class="col-12 col-md-2 d-flex justify-content-start justify-content-xl-center">
              <div class="circle--placeholder"></div>
            </div>
            <div class="col-12 col-md-10">
              <div class="row">
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="sports"
                               label="{{t('app.common.sports')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="sports"
                               label="{{t('app.common.club')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="clubs"
                               label="{{t('app.common.clubs')}}" [readonly]="true"></app-input>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="category"
                               label="{{t('app.common.category')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="height"
                               label="{{t('app.common.height')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="weight"
                               label="{{t('app.common.weight')}}" [readonly]="true"></app-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="tShirtSize"
                               label="{{t('app.common.tshirtSize')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="footwearSize"
                               label="{{t('app.common.footwearSize')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="identityCardNumber"
                               label="{{t('app.common.identityCardNumber')}}" [readonly]="true"></app-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="identityCardIssuer"
                               label="{{t('app.common.identityCardIssuer')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="identityCardExpires"
                               label="{{t('app.common.identityCardExpires')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="emergencyPhone"
                               label="{{t('app.common.emergencyPhone')}}" [readonly]="true"></app-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-6">
                  <div class="mb-3">
                    <app-input formControlName="meal"
                               label="{{t('app.common.meal')}}" [readonly]="true"></app-input>
                  </div>
                </div>
                <div class="col-xl-4 col-6">
                  <div class="form-floating mb-3">
                    <app-input formControlName="transport"
                               label="{{t('app.common.transport')}}" [readonly]="true"></app-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-admin-card-with-title>
      }
    </div>
  </form>
</ng-container>
